// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__23ZQp","loaderOuter":"PageOverlayLoader_loaderOuter__16t3o"};